@if (nextStep(); as step) {
  <div
    class="flex flex-col gap-4 rounded-lg border border-primary-200 bg-primary-50 p-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <div class="flex items-start gap-3">
      <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white text-primary-600"
      >
        <lucide-icon name="rocket" [size]="20" />
      </div>

      <div class="min-w-0">
        <p
          class="text-paragraph-xs-med uppercase tracking-wide text-primary-700"
        >
          {{ "help.onboarding.journey.nextLabel" | transloco }}
        </p>
        <p class="text-paragraph-med text-greyscale-950">
          {{ "help.onboarding.journey.steps." + step.key | transloco }}
        </p>
        @if (phaseContext(); as context) {
          <p class="mt-0.5 text-paragraph-xs-reg text-greyscale-600">
            {{ context.position }} ·
            {{
              "help.onboarding.journey.phases." + context.phase + ".title"
                | transloco
            }}
          </p>
        }
      </div>
    </div>

    @if (showCta()) {
      <app-journey-step-cta [stepKey]="step.key" [prominent]="true" />
    }
  </div>
} @else if (isComplete()) {
  <div
    class="flex items-center gap-4 rounded-lg border border-primary-300 bg-primary-50 p-4"
  >
    <div
      class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary-500 text-white"
    >
      <lucide-icon name="trophy" [size]="24" />
    </div>
    <div class="min-w-0">
      <p class="text-heading-4 text-greyscale-950">
        {{ "help.onboarding.journey.allDone.title" | transloco }}
      </p>
      <p class="text-paragraph-s-reg text-greyscale-600">
        {{ "help.onboarding.journey.allDone.description" | transloco }}
      </p>
    </div>
  </div>
}
